import { Application, Container } from 'pixi.js'
import { FlyArea } from './layout/FlyArea'
import { CrashHistoryBar } from './layout/CrashHistoryBar'

export class Main extends Container {
	public flyArea!: FlyArea
	public historyBar!: CrashHistoryBar
	private app: Application
	private resizeRaf = 0

	constructor(app: Application) {
		super()
		this.app = app
		this.init()
		this.layout()
		this.app.renderer.on('resize', this.onRendererResize, this)
	}

	destroy(options?: boolean | { children?: boolean; texture?: boolean; baseTexture?: boolean }) {
		this.app.renderer.off('resize', this.onRendererResize, this)
		if (this.resizeRaf) {
			cancelAnimationFrame(this.resizeRaf)
		}
		super.destroy(options)
	}

	private onRendererResize = () => {
		if (this.resizeRaf) {
			cancelAnimationFrame(this.resizeRaf)
		}

		this.resizeRaf = requestAnimationFrame(() => {
			this.resizeRaf = 0
			this.layout()
		})
	}

	private init() {
		this.flyArea = new FlyArea(this.app)
		this.historyBar = new CrashHistoryBar()
		this.addChild(this.flyArea)
		this.flyArea.addChild(this.historyBar)
	}

	private layout() {
		const width = this.app.screen.width
		const height = this.app.screen.height

		this.flyArea.position.set(0, 0)
		this.flyArea.resize(width, height)

		const historyWidth = Math.min(width - 16, width * 0.92)
		const historyHeight = Math.max(32, Math.min(48, height * 0.08))
		this.historyBar.resize(historyWidth, historyHeight)
		this.historyBar.position.set((width - historyWidth) / 2, Math.max(8, height * 0.02))
	}
}
